import { Close, Edit, EditOutlined, ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, Grid, Modal, TextField, Typography, useTheme } from "@mui/material";
import moment from "moment";
import React from "react";

export default function PermitsHistory(props) {
  const theme = useTheme();
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      backgroundColor: '#fff',
      height: '100%'
    }}>
      {props.history.map((x, index) => {
        return (
          <Accordion sx={{ width: '100%' }}>
            <AccordionSummary
              sx={{ p: 0, background: '#f8f8f8' }}
              expandIcon={<ExpandMore />}
              onClick={() => props.getTransactionDetail(x, index)}
            >
              <Box sx={{ width: '100%', px: 2 }}>
                {x.status == "cancelled" && <Box>
                  <Typography variant='caption' align='left' sx={{color: '#af0000', background: '#af00004f', px: 2, borderRadius: '10px'}} >
                    {props.literals.cancelled}
                  </Typography>
                  {x.note && <Grid>
                    <Typography variant='caption' align='left' sx={{ color: 'primary.main', fontWeight: 'bold' }} >
                      {props.literals.cancel_reason}:&nbsp;&nbsp;
                        <Typography variant='caption' align='left' sx={{ color: 'black'}}>
                          {x.note}
                      </Typography>
                    </Typography>
                  </Grid>}
                </Box>}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'black' }}>
                  <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
                    {moment(x.from).format("MMMM Do YYYY, hh:mm a")}
                  </Typography>
                  <Grid>
                    <Grid>
                      <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
                        {x.permit?.permit_name}
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
                        {x.zone?.zone_name}, {x.city?.city_name}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Divider />
                <Box sx={{ display: 'flex', marginTop: 2, justifyContent: 'space-between', alignItems: 'center', color: 'black' }}>
                  <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
                    {props.literals.parking_session_end_at}
                  </Typography>
                  <Grid>
                    <Typography variant='caption' align='left'
                      sx={{ background: theme.palette.primary.main, color: '#FFF', padding: '5px 23px', borderRadius: '17px' }}
                    >
                      {x.plate}
                    </Typography>
                    {moment() < moment(x.to) && <Button
                      type="button"
                      onClick={() => props.onEdit(x, index)}
                    >
                      <EditOutlined />
                    </Button>}
                  </Grid>
                </Box>
                <Box sx={{ display: 'flex', marginTop: 2, justifyContent: 'space-between', alignItems: 'center', color: 'black' }}>
                  <Typography variant='subtitle2' align='left' sx={{ color: 'primary.main' }} >
                    {moment(x.to).format("MMM Do YYYY")}
                  </Typography>
                  <Typography variant='h6' align='left' sx={{ color: 'primary.main' }} >
                    {moment(x.to).format("hh:mm a")}
                  </Typography>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {!x.transactions?.length &&
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Divider sx={{ background: theme.palette.primary.main }} />
                  </Grid>
                  <Grid item xs={12} textAlign={'center'}>
                    {props.literals.no_record_found}
                  </Grid>
                </Grid>
              }
              {x.transactions?.map((y, i) => {
                return (
                  <Grid container spacing={2}>
                    {y.allow_auto_renew && i == 0 && <Grid item md={12} align='end'>
                        <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                          onClick={() => props.openConfirmDialog({id: y._id, historyIndex: index, transactionIndex: i})}
                        >
                          Unsubscribe
                        </Button>
                    </Grid>}
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='caption' align='left'>
                        {props.literals.transaction_date}
                      </Typography>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='subtitle2' align='left' sx={{ fontWeight: 'bold' }} >
                        {moment(y.transaction_date).format("MMMM Do YYYY, hh:mm a")}
                      </Typography>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='caption' align='left'>
                        {props.literals.amount}
                      </Typography>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='subtitle2' align='left' sx={{ fontWeight: 'bold' }} >
                        CA$ {(y.amount / 100).toFixed(2)}
                      </Typography>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='caption' align='left'>
                        {props.literals.permit_start_date}
                      </Typography>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='subtitle2' align='left' sx={{ fontWeight: 'bold' }} >
                        {moment(y.parking_from).format("MMMM Do YYYY, hh:mm a")}
                      </Typography>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='caption' align='left'>
                        {props.literals.permit_end_date}
                      </Typography>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='subtitle2' align='left' sx={{ fontWeight: 'bold' }} >
                        {moment(y.parking_to).format("MMMM Do YYYY, hh:mm a")}
                      </Typography>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='caption' align='left'>
                        {props.literals.allow_auto_renew}
                      </Typography>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='subtitle2' align='left' sx={{ fontWeight: 'bold' }} >
                        {y.allow_auto_renew ? 'Yes' : 'No'}
                      </Typography>
                    </Grid>
                    {y.allow_auto_renew && <><Grid item md={3} sm={6} xs={6}>
                      <Typography variant='caption' align='left'>
                        {props.literals.next_renew_at}
                      </Typography>
                    </Grid>
                      <Grid item md={3} sm={6} xs={6}>
                        <Typography variant='subtitle2' align='left' sx={{ fontWeight: 'bold' }} >
                          {moment(y.next_renew_at).format("MMMM Do YYYY, hh:mm a")}
                        </Typography>
                      </Grid></>}
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='caption' align='left'>
                        {props.literals.payment_status}
                      </Typography>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                      <Typography variant='subtitle2' align='left' sx={{ fontWeight: 'bold' }} >
                        {y.payment_status}
                      </Typography>
                    </Grid>
                    {y.payment_status !== 'succeeded' && <>
                      <Grid item md={3} sm={6} xs={6}>
                        <Typography variant='caption' align='left'>
                          {props.literals.failure_reason}
                        </Typography>
                      </Grid>
                      <Grid item md={3} sm={6} xs={6}>
                        <Typography variant='subtitle2' align='left' sx={{ fontWeight: 'bold' }} >
                          {y.failure_reason}
                        </Typography>
                      </Grid>
                    </>}
                    {x.transactions.length !== (i + 1) && <Grid item xs={12}>
                      <Divider sx={{ background: theme.palette.primary.main }} />
                    </Grid>}
                  </Grid>
                )
              })}
            </AccordionDetails>
          </Accordion>
        )
      })}
      <Modal
        open={props.showPlateModal}
        onClose={() => props.setShowPlateModal(false)}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 2
        }}>
          <Box component="form" onSubmit={props.onEditParking} sx={{ p: 3, width: '100%' }}>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Typography variant='subtitle1' color="primary">
                  {props.literals.edit_plate}
                </Typography>
              </Grid>
              <Grid item xs={6} align='end'>
                <Button
                  type='buton'
                  onClick={() => props.setShowPlateModal(false)}
                >
                  <Close />
                </Button>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label={props.literals.plate}
                  color="primary"
                  name="plate"
                  value={props.plate}
                  onChange={(e) => props.setPlate(e.target.value.toUpperCase())}
                  size="small"
                  required
                  fullWidth
                >
                </TextField>
              </Grid>
              <Grid item xs={12} align='center'>
                <Button
                  type='submit'
                  size='large'
                  variant='contained'
                  sx={{ borderRadius: 8, width: '100%', my: 2 }}
                >
                  {props.literals.edit_plate}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}